/**
 * 商品详情页
 */
const goodsInfoLangCN = {
    ServiceDescription:"服务说明",
    ProductParameters:"商品参数",
    ChooseSpecifications: "选择规格",
    BabyDetails: "宝贝详情",
    IWantToBuy:"我要买",
    determine:"确定",
    BuyNow:"立即购买",
    shoppingCart:"购物车",
    AddShoppingCart:"加入购物车",
    WorryFreeRefund:"无忧退款",
    QuickRefund:"快速退款",
    FreePackageShipping:"免费包邮",
    ProductInformation:"商品信息",
}

const goodsInfoLangEN = {
    ServiceDescription:"Service description",
    ProductParameters:"Products parameters",
    ChooseSpecifications: "Choose specifications",
    BabyDetails: "宝贝详情",
    IWantToBuy:"我要买",
    determine:"确定",
    BuyNow:"Purchase now",
    shoppingCart:"Cart",
    AddShoppingCart:"Add to the cart",
    WorryFreeRefund:"Worry free refund",
    QuickRefund:"Quick Refund",
    FreePackageShipping:"Free package shipping",
    ProductInformation:"Product Information",
}

const langPackage = {
    cn:goodsInfoLangCN,
    en:goodsInfoLangEN
}

export {langPackage}
